/**
 * @fileoverview POST handler for the "/engagement/update_ios_notification_groups" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementIosNotificationGroupsCacheKeys } from "./constants";
import type { UpdateIosNotificationGroupsProps, UpdateIosNotificationGroupsResult } from "./types";

export const updateIosNotificationGroups = reactQueryMutationAdapter(
  engagementIosNotificationGroupsCacheKeys,
  (props: UpdateIosNotificationGroupsProps): Promise<UpdateIosNotificationGroupsResult> => {
    return fetch(`/engagement/update_ios_notification_groups`, "POST", props);
  }
);
